import { timeStringToMs } from '../../utility/DateFormatter';
import { Registry } from '@lightningjs/sdk';
import { EpgApi } from '../../../api/EpgApi';
import { EpgUtil } from '../../utility/EpgUtil';
import { Backend } from '../../../api/Backend';
import { UiEventHandlers } from '../ui/UiEventHandlers';
import { LinearStreamInfo } from '../streamInfo/LinearStreamInfo';

export class UpdateScheduleHandler {
  private _backend: Backend;
  private _streamInfo: LinearStreamInfo;
  private _uiEventHandlers: UiEventHandlers;
  private _updateScheduleTimer: number | undefined;
  constructor(backend: Backend, streamInfo: LinearStreamInfo, uiEventHandlers: UiEventHandlers) {
    this._backend = backend;
    this._streamInfo = streamInfo;
    this._uiEventHandlers = uiEventHandlers;
  }

  start() {
    this._startUpdateScheduleTimer();
  }

  stop() {
    this._stopUpdateScheduleTimer();
  }

  _startUpdateScheduleTimer() {
    this._stopUpdateScheduleTimer();
    let duration = timeStringToMs(this._streamInfo.schedule.published.end) - Date.now();
    duration = duration > 0 ? duration : 30000;
    this._updateScheduleTimer = Registry.setTimeout(() => this._updateSchedule(), duration);
  }

  _updateSchedule() {
    const scheduleTimes = EpgUtil.getTodayFromUntil();
    this._backend.playerController.analyticsHandler?.logPlayStop();
    EpgApi.channelSchedules(this._backend, this._streamInfo.assetId, scheduleTimes.from, scheduleTimes.until).then(
      result => {
        const newSchedule = EpgUtil.findCurrentSchedule(result.schedules);
        if (newSchedule) {
          this._streamInfo.schedule = newSchedule;
          const foundProgram = result.programs?.find(p => p.id === newSchedule.program);
          if (foundProgram) this._streamInfo.program = foundProgram;
        }

        this._uiEventHandlers.updateTitleBarHandler(this._streamInfo);
        this._updateScheduleTimer = undefined;
        this._backend.playerController.analyticsHandler?.logPlayStart();
        this._startUpdateScheduleTimer();
      }
    );
  }

  _stopUpdateScheduleTimer() {
    if (this._updateScheduleTimer) {
      Registry.clearTimeout(this._updateScheduleTimer);
      this._updateScheduleTimer = undefined;
    }
  }
}
